import { Link } from 'react-router-dom';

const PREVIEW_TEMPLATES = [
  { name: 'Romantic Classic', slug: 'preview-romantic-classic', description: 'Split hero with soft editorial spacing and romantic card styling.' },
  { name: 'Minimal Modern', slug: 'preview-minimal-modern', description: 'Centered hero, clean typography, and crisp minimalist section rhythm.' },
  { name: 'Botanical', slug: 'preview-botanical', description: 'Full-image hero, organic tone, and warm layered content cards.' },
  { name: 'Luxury Editorial', slug: 'preview-luxury-editorial', description: 'Asymmetric premium hero with elevated contrast and luxury accents.' },
  { name: 'Coastal', slug: 'preview-coastal', description: 'Gibraltar-inspired sea palette, airy sections, and serene visual flow.' },
  { name: 'Floral', slug: 'preview-floral', description: 'Centered floral hero with delicate sections and soft decorative feel.' },
  { name: 'Modern', slug: 'preview-modern', description: 'Vertical split hero, bold typography, and sharp modern section framing.' },
  { name: 'Classic', slug: 'preview-classic', description: 'Traditional wedding structure with timeless spacing and refined cards.' },
  { name: 'Rustic', slug: 'preview-rustic', description: 'Natural tones, warm typography, and grounded rustic section styling.' },
  { name: 'Dark Elegant', slug: 'preview-dark-elegant', description: 'Dark premium hero with rich contrast and elegant evening mood.' },
];

export default function WeddingTemplatePreviewGalleryPage() {
  return (
    <div className="min-h-screen bg-stone-100 py-10" data-testid="template-preview-gallery-page">
      <div className="container-wedding space-y-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] text-[#5C0120] font-semibold mb-3">Wedding Website Builder</p>
          <h1 className="text-4xl sm:text-5xl font-semibold text-stone-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Real Template Previews (Mobile First)
          </h1>
          <p className="text-stone-600">
            Sample couple: <strong>Sofia & Daniel</strong> · <strong>14 Oct 2026</strong> · <strong>The Rock Hotel, Gibraltar</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6" data-testid="template-preview-grid">
          {PREVIEW_TEMPLATES.map((template) => (
            <article key={template.slug} className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={`template-preview-card-${template.slug}`}>
              <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                <div>
                  <h2 className="text-xl font-semibold text-stone-900" data-testid={`template-preview-name-${template.slug}`}>{template.name}</h2>
                  <p className="text-sm text-stone-600" data-testid={`template-preview-description-${template.slug}`}>{template.description}</p>
                </div>
                <Link
                  to={`/wedding/${template.slug}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-semibold text-[#5C0120] hover:text-[#5C0120]/80"
                  data-testid={`template-preview-open-link-${template.slug}`}
                >
                  Open full preview →
                </Link>
              </div>

              <div className="rounded-[2rem] border-[8px] border-stone-900 bg-black overflow-hidden mx-auto w-[390px] max-w-full" data-testid={`template-preview-phone-frame-${template.slug}`}>
                <iframe
                  title={`${template.name} mobile preview`}
                  src={`/wedding/${template.slug}`}
                  className="w-full h-[760px] bg-white"
                  loading="lazy"
                  data-testid={`template-preview-iframe-${template.slug}`}
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
